<template>
    <div class="specialist-article">
        <div class="specialist-article__image">
            <img :src="imageUrl">
            <div class="specialist-article__gradient-overlay"></div>
        </div>
        <div class="specialist-article__title">
            {{title}}
        </div>
        <div class="specialist-article__categories">
                {{this.displayCategories}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            imageUrl: {
                type: String,
                default: ''
            },
            categories: {
                type: Array,
                default: []
            }
        },
        computed: {
            displayCategories: function (){
                let categoriesLine = "";
                this.categories.forEach((category, i) => {
                    if(i+1 != this.categories.length) categoriesLine += category.name + ", ";
                    else categoriesLine += category.name;
                })

                return categoriesLine;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .specialist-article {
        display: flex;
        flex-direction: column;
        max-width: 100%;
        cursor: pointer;
        margin: 0 auto;

        &:hover & {

            &__gradient-overlay {
                opacity: .6;
            }

            &__title {
                color: $color-primary;
            }
        }

        @include media-breakpoint-up(sm) {
            max-width: 330px;
        }

        &__image {
            position: relative;
            height: 110px;
            width: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        &__gradient-overlay {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-image: $gradient-nexyo;
            transition: opacity .2s;
            opacity: 0;
        }

        &__title {
            font-size: 18px;
            font-weight: 400;
            line-height: 20px;
            color: $color-gray;
            margin-top: 12px;
        }

        &__categories {
            font-size: 14px;
            font-weight: 300;
            line-height: 20px;
            color: rgba($color-gray, .5);
            margin-top: 10px;
            display: flex;
            width: 100%;
            flex-wrap: wrap;
        }
    }
</style>